import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;
export const TierInfoCard = styled.div`
  height: 100%;
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    gap: 0.25rem;
  }
  @media (max-width: ${({ theme }) => theme.media.md}) {
    justify-content: center;
    display: flex;
    padding: 10px 0;
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: row;
  }
`;

export const TierInfoMilage = styled.div<{ $color: string }>`
  min-height: ${({ theme }) => theme.spacing.x23};
  min-width: 138px;
  background-size: cover;
  position: relative;
  border-radius: ${({ theme }) => theme.rounded.x3};
  display: flex;
  ${({ $color }) =>
    $color === 'blue'
      ? css`
          background: linear-gradient(177.23deg, #77a2fc -13.49%, #5285ed 109.75%);
          margin-inline-start: ${({ theme }) => theme.spacing.x2};
        `
      : $color === 'green'
      ? css`
          background: linear-gradient(176.33deg, #80d3ab -5.28%, #3aad76 109.03%);
        `
      : $color === 'gray'
      ? css`
          background: linear-gradient(177.23deg, #a3a3a3 -13.49%, #737373 109.75%);
          margin-inline-start: ${({ theme }) => theme.spacing.x2};
        `
      : ''}
  & > * {
    z-index: 1;
  }
  @media (max-width: ${({ theme }) => theme.media.lg}) {
    margin-inline-start: ${({ theme }) => theme.spacing.x2};
  }
  @media (max-width: ${({ theme }) => theme.media.sm}) {
    margin-inline-start: 0;
  }
`;

export const TierInfoBg = styled.div`
  position: absolute;
  inset: 0 0 0 0;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 12px;
`;
export const TierInfoTitle = styled.span`
  color: ${({ theme }) => theme.palette.white};
  margin-bottom: ${({ theme }) => theme.spacing.x1};
  font-size: ${({ theme }) => theme.fs.sm};
`;
export const TierInfoCount = styled.span`
  color: ${({ theme }) => theme.palette.white};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fs.xl};
`;
